import { IsOptional, IsString, IsArray, IsNotEmpty } from 'class-validator';

export class AccountGroupsDto {
  @IsString({ groups: ['form'] })
  @IsNotEmpty({ groups: ['form'] })
  variant: string;

  @IsArray({ groups: ['form'] })
  @IsString({ each: true, groups: ['form'] })
  @IsOptional({ groups: ['form'] })
  groups?: string[];

  @IsArray({ groups: ['form'] })
  @IsString({ each: true, groups: ['form'] })
  @IsOptional({ groups: ['form'] })
  users?: string[];

  @IsString({ groups: ['form'] })
  @IsOptional({ groups: ['form'] })
  user?: string;

  @IsString({ groups: ['form'] })
  @IsOptional({ groups: ['form'] })
  group?: string;
}
